/**
 * Analytics layer. Vendor-agnostic and privacy-first:
 *  - first-party events -> POST /api/marketing/events (no cookies; per-tab session id)
 *  - optional Plausible (REACT_APP_PLAUSIBLE_DOMAIN) or GA4 (REACT_APP_GA_ID) mirrors
 *  - UTM / referrer / landing captured once per session and attached to every lead
 *
 * Usage: track("cta_click", { where: "hero" }); every CTA in the site calls this.
 */
import { api } from "./api";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const SS = typeof window !== "undefined" ? window.sessionStorage : null;

function sid() {
  if (!SS) return "";
  let s = SS.getItem("pn_sid");
  if (!s) { s = Math.random().toString(36).slice(2, 12) + Date.now().toString(36); SS.setItem("pn_sid", s); }
  return s;
}

export function captureAttribution() {
  if (!SS || SS.getItem("pn_attr")) return;
  const q = new URLSearchParams(window.location.search);
  const attr = {};
  UTM_KEYS.forEach((k) => { const v = q.get(k); if (v) attr[k] = v.slice(0, 200); });
  if (document.referrer && !document.referrer.includes(window.location.host)) attr.referrer = document.referrer.slice(0, 200);
  attr.landing = (window.location.pathname + window.location.search).slice(0, 200);
  SS.setItem("pn_attr", JSON.stringify(attr));
}

export function attribution() {
  try { return JSON.parse(SS?.getItem("pn_attr") || "{}"); } catch { return {}; }
}

export function track(event, props = {}) {
  const page = typeof window !== "undefined" ? window.location.pathname : "";
  // first-party
  api.post("/marketing/events", { event, props, page, sid: sid() }).catch(() => {});
  // mirrors
  if (window.plausible) window.plausible(event, { props });
  if (window.gtag) window.gtag("event", event, props);
}

export function pageview(path) {
  track("page_view", { path });
}

export function installVendors() {
  const pl = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
  if (pl && !document.querySelector("script[data-domain]")) {
    const s = document.createElement("script"); s.defer = true; s.dataset.domain = pl; s.src = "https://plausible.io/js/script.js"; document.head.appendChild(s);
  }
  const ga = process.env.REACT_APP_GA_ID;
  if (ga && !window.gtag) {
    const s = document.createElement("script"); s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`; document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date()); window.gtag("config", ga, { anonymize_ip: true });
  }
}
